import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mercedesbenzcabrentalsinmumbai() {



  const cardData =
  {
    keyword: 'Mercedes Benz Cab Rentals in Mumbai',
    heading: 'Aaryan Travels: Mercedes Benz Cab Rentals in Mumbai',
    headingDescription: 'Aaryan Travels offers premium Mercedes Benz Cab Rentals in Mumbai for corporate executives, VIP guests, weddings, and luxury travel seekers. Whether it’s an airport pickup from Chhatrapati Shivaji Maharaj International Airport, a high-profile business meeting in BKC, or a grand wedding entrance, our chauffeur-driven Mercedes sedans ensure unmatched class and comfort. With professional uniformed chauffeurs, plush interiors, and amenities like bottled water and on-request Wi-Fi, we deliver a royal travel experience across South Mumbai, Bandra, Andheri, and Navi Mumbai. Aaryan Travels is the trusted choice for Mercedes Benz cab rentals in Mumbai for those who expect nothing but the best.',

    top: 'Top Places to Visit in Mumbai with Aaryan Travels',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "Built in 1924 overlooking the Arabian Sea, the Gateway of India is Mumbai’s most iconic monument. It once served as a ceremonial entrance during British rule. Tourists gather here to take ferry rides and enjoy the sea breeze. The majestic arch glows beautifully at night. The Gateway of India is Mumbai’s grand symbol of history and pride."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also known as the Queen’s Necklace, is a 3.6 km-long seaside promenade. People visit for evening walks, ocean views, and roadside snacks like bhelpuri. At night, the streetlights create a sparkling necklace-like effect. It’s a favorite hangout for locals and tourists alike. Marine Drive is Mumbai’s timeless coastal escape."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "CST is a UNESCO World Heritage railway station built in 1887 in Victorian Gothic style. Its domes, stained-glass windows, and carvings make it look like a grand palace. Despite its historical charm, it serves as one of India’s busiest transport hubs. Illuminated at night, it offers a spectacular view. CST is Mumbai’s iconic blend of heritage and hustle."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most popular beach, known for its lively atmosphere and street food like pav bhaji and gola. Families enjoy camel rides while children play in the sands. Bollywood celebrities often live nearby, adding star value. Sunsets here are vibrant and memorable. Juhu Beach is Mumbai’s fun-filled seaside hangout."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a 15th-century mosque and tomb located on a small islet in the Arabian Sea. Connected by a narrow causeway, it appears to float during high tide. People of all faiths visit to seek blessings and listen to qawwali music. The white marble structure offers peace and beauty. Haji Ali is Mumbai’s spiritual sanctuary by the sea."
  },
  {
    "title": "Elephanta Caves",
    "description": "Located on Elephanta Island, these UNESCO-protected rock-cut caves date back to the 5th century. The main cave features magnificent sculptures of Lord Shiva, including the iconic Trimurti. Visitors reach the island via ferry from the Gateway of India. Surrounded by nature and history, it offers a thrilling heritage experience. Elephanta Caves are Mumbai’s ancient treasure."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most revered shrines dedicated to Lord Ganesha. Devotees, including film stars and politicians, line up for blessings. The gold-plated dome and intricately carved idol add to its sacred charm. Tuesdays witness heavy footfall for special prayers. Siddhivinayak is Mumbai’s divine blessing hub."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a modern engineering marvel connecting South Mumbai to the suburbs. Driving across offers panoramic sea views and city skyline. At night, the illuminated cables look breathtaking. It has reduced travel time while adding futuristic appeal. The Sea Link is Mumbai’s symbol of modern progress."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is a bustling street market famous for fashion accessories, antiques, and handicrafts. Shoppers enjoy bargain hunting while savoring local snacks. Iconic cafes like Leopold Café and Café Mondegar add vintage charm. It’s a must-visit for tourists. Colaba Causeway is Mumbai’s vibrant shopping lane."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park is one of the largest urban forests in the world. Visitors enjoy jungle safaris, nature trails, and boat rides. The ancient Kanheri Caves inside the park add historical depth. Deer, monkeys, and birds are commonly spotted. SGNP is Mumbai’s refreshing nature retreat."
  }
],


"services": [
  {
    "name": "Mercedes Benz Cab Rentals in Mumbai",
    "description": "Mercedes Benz Cab Rentals in Mumbai offer a luxurious and reliable travel experience with a fleet of premium Mercedes vehicles. Whether you need transportation for business meetings, special events, or airport transfers, our professional chauffeurs ensure a comfortable, punctual, and seamless journey. Our service is tailored to meet the demands of discerning travelers who seek the perfect blend of style, safety, and convenience in every ride."
  },
  {
    "name": "Mercedes Cab Hire Mumbai",
    "description": "Mercedes Cab Hire Mumbai provides access to a variety of Mercedes models, available for short or long-term rental with professional drivers. Ideal for corporate clients and luxury travelers alike, this service promises punctual pickups, comfortable rides, and exceptional customer care. Our chauffeurs are well-trained to provide discreet, efficient service, allowing you to focus on your priorities while enjoying premium travel."
  },
  {
    "name": "Chauffeur Mercedes Mumbai",
    "description": "Chauffeur Mercedes Mumbai features professional drivers dedicated to delivering high-quality chauffeur services with Mercedes vehicles. Whether for corporate travel or special occasions, our chauffeurs ensure a smooth and stress-free journey, handling your route planning and offering courteous assistance throughout your ride."
  },
  {
    "name": "Executive Mercedes Mumbai",
    "description": "Executive Mercedes Mumbai caters to business professionals seeking a sophisticated and reliable mode of transportation. With plush interiors, modern amenities, and experienced chauffeurs, this service provides an ideal environment for executives to prepare for meetings or unwind after a busy day. Timeliness and discretion are key priorities."
  },
  {
    "name": "Mercedes Sedan Rental Mumbai",
    "description": "Mercedes Sedan Rental Mumbai offers sleek, elegant sedans perfect for solo travelers or small groups. Equipped with advanced climate control, spacious interiors, and professional drivers, these sedans ensure a refined and relaxing travel experience for airport transfers, city rides, and business trips."
  },
  {
    "name": "Mercedes SUV Rental Mumbai",
    "description": "Mercedes SUV Rental Mumbai provides spacious and luxurious SUVs ideal for group travel, families, or clients with extra luggage. Featuring advanced safety features and plush seating, our SUVs driven by expert chauffeurs guarantee a comfortable and secure ride, tailored to your needs."
  },
  {
    "name": "Premium Mercedes Cab Mumbai",
    "description": "Premium Mercedes Cab Mumbai delivers high-end transportation services using the latest Mercedes models. Our chauffeurs offer personalized service, real-time ride tracking, and flexible booking options, ensuring your journey is not only luxurious but also efficient and stress-free."
  },
  {
    "name": "Corporate Mercedes Rental Mumbai",
    "description": "Corporate Mercedes Rental Mumbai is designed for businesses requiring dependable, upscale transportation for executives, clients, and staff. We offer customizable rental packages, priority booking, and professional chauffeurs trained in corporate etiquette to support your company’s travel needs with style and professionalism."
  },
  {
    "name": "Best Mercedes Cab Mumbai",
    "description": "Best Mercedes Cab Mumbai is recognized for its superior service quality, combining a premium fleet with punctual drivers and 24/7 availability. We focus on delivering consistent excellence in every ride, making us the preferred choice for luxury cab rentals across Mumbai."
  },
  {
    "name": "Affordable Mercedes Cab Mumbai",
    "description": "Affordable Mercedes Cab Mumbai provides luxury rides at competitive prices without compromising on vehicle quality or service standards. Perfect for travelers who want to experience Mercedes comfort and style on a budget, with transparent pricing and no hidden fees."
  },
  {
    "name": "Mercedes Chauffeur Services Mumbai",
    "description": "Mercedes Chauffeur Services Mumbai offers expertly trained chauffeurs dedicated to providing discreet, courteous, and professional driving. Whether for business, leisure, or special events, our chauffeurs ensure your Mercedes ride is smooth, safe, and tailored to your preferences."
  },
  {
    "name": "Mercedes Packages Mumbai",
    "description": "Mercedes Packages Mumbai includes a variety of rental plans and service bundles designed to meet diverse travel requirements. From hourly rentals to long-term corporate packages, our flexible offerings provide cost-effective access to luxury Mercedes vehicles with professional chauffeurs."
  },
  {
    "name": "Mercedes Car Hire Mumbai",
    "description": "Mercedes Car Hire Mumbai offers a broad selection of Mercedes vehicles available for hire with or without drivers. Our fleet is maintained to the highest standards, ensuring safety, cleanliness, and luxury for all your transportation needs across the city."
  },
  {
    "name": "Online Mercedes Cab Mumbai",
    "description": "Online Mercedes Cab Mumbai provides a convenient digital platform for booking premium Mercedes cabs anytime, anywhere. Enjoy instant booking confirmations, fare transparency, and real-time tracking through our user-friendly website and mobile app, simplifying luxury travel in Mumbai."
  },
  {
    "name": "Mercedes Chauffeur Booking Mumbai",
    "description": "Mercedes Chauffeur Booking Mumbai offers seamless online reservations for chauffeur-driven Mercedes rides. With easy scheduling, flexible options, and professional drivers, this service ensures your luxury transportation is arranged efficiently and reliably."
  }
],
"tableData": [
  ["Mercedes Benz Cab Rentals in Mumbai", "Mercedes Cab Hire Mumbai"],
  ["Chauffeur Mercedes Mumbai", "Executive Mercedes Mumbai"],
  ["Mercedes Sedan Rental Mumbai", "Mercedes SUV Rental Mumbai"],
  ["Premium Mercedes Cab Mumbai", "Corporate Mercedes Rental Mumbai"],
  ["Best Mercedes Cab Mumbai", "Affordable Mercedes Cab Mumbai"],
  ["Mercedes Chauffeur Services Mumbai", "Mercedes Packages Mumbai"],
  ["Mercedes Car Hire Mumbai", "Online Mercedes Cab Mumbai"],
  ["Mercedes Chauffeur Booking Mumbai", "—"]
],

"whychoose": [
  {
    "WhyChooseheading": "Mercedes Benz Cab Rentals in Mumbai",
    "WhyChoosedescription": "Aaryan Travels offers premium Mercedes Benz cab rentals in Mumbai for luxury, comfort, and class on every ride."
  },
  {
    "WhyChooseheading": "Chauffeur-Driven Luxury Experience",
    "WhyChoosedescription": "Enjoy the services of professional, uniformed chauffeurs trained to deliver a first-class travel experience."
  },
  {
    "WhyChooseheading": "Clean and Well-Maintained Mercedes Vehicles",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned Mercedes cars that are regularly maintained for maximum safety and comfort."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Route Expertise",
    "WhyChoosedescription": "Our drivers are well-versed with Mumbai’s roads and traffic, ensuring smooth and efficient travel."
  },
  {
    "WhyChooseheading": "Upfront Pricing with No Hidden Charges",
    "WhyChoosedescription": "Get transparent pricing inclusive of fuel, tolls, and driver charges—no last-minute surprises."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Bookings and Assistance",
    "WhyChoosedescription": "Our dedicated team is available round the clock to assist you with reservations and travel inquiries."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Choose from hourly, daily, or special event packages tailored to your travel needs."
  },
  {
    "WhyChooseheading": "Perfect for Corporate, Leisure, or VIP Travel",
    "WhyChoosedescription": "Ideal for business executives, weddings, or luxury city tours, our Mercedes rentals elevate every journey."
  }
]











  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer Mercedes Benz cab rentals in Mumbai?',
    answer: 'Yes, Aaryan Travels provides premium Mercedes Benz cab rentals in Mumbai for luxury travel experiences, corporate needs, and special occasions.',
  },
  {
    question: 'How can I book a Mercedes Benz cab in Mumbai with Aaryan Travels?',
    answer: 'You can book quickly through our website, mobile app, or by contacting our 24x7 luxury cab support team.',
  },
  {
    question: 'Which Mercedes Benz models are available for cab rentals in Mumbai?',
    answer: 'We offer a range of Mercedes Benz models such as C-Class, E-Class, and S-Class based on availability and your preferences.',
  },
  {
    question: 'Are chauffeurs included with Mercedes Benz cab rentals in Mumbai?',
    answer: 'Yes, all Mercedes Benz rentals come with professionally trained, uniformed chauffeurs to ensure a premium experience.',
  },
  {
    question: 'Can I book a Mercedes Benz cab for airport transfers or business meetings in Mumbai?',
    answer: 'Absolutely. Our luxury cab services are ideal for airport pickups, corporate travel, VIP guest transport, and high-end events.',
  },
  {
    question: 'Is the Mercedes Benz cab rental service available 24x7 in Mumbai?',
    answer: 'Yes, Aaryan Travels offers round-the-clock Mercedes Benz cab services to match your travel plans.',
  },
  {
    question: 'Are hygiene and safety protocols maintained in Mercedes Benz cab rentals?',
    answer: 'Yes, all vehicles are thoroughly sanitized before every trip, and our chauffeurs follow strict safety and hygiene standards.',
  },
  {
    question: 'What are the payment options for Mercedes Benz cab rentals in Mumbai?',
    answer: 'We accept payments via cash, credit/debit cards, UPI, digital wallets, and corporate billing accounts.',
  },
  {
    question: 'Is customer support available during Mercedes Benz cab rides in Mumbai?',
    answer: 'Yes, our 24x7 customer support team is always available to assist you throughout your rental experience.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Desai',
    feedback: 'Booked a Mercedes Benz through Aaryan Travels in Mumbai — everything from booking to the ride was smooth and luxurious.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Ayesha Khan',
    feedback: 'Fantastic service! The Mercedes was pristine, and the chauffeur was extremely professional. Perfect for my business event in Mumbai.',
    rating: 5,
  },
];

























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];









const mercedesMumbaiSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Mercedes Benz Cab Rentals in Mumbai",
  "description": "Aaryan Travels provides chauffeur driven Mercedes Benz cab rentals in Mumbai, offering luxury sedans and SUVs for executive, corporate, and premium travel needs.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Mumbai"
  },
  "serviceType": "Chauffeur Driven Mercedes Benz Cab Rental Service",
  "keywords": "Mercedes Benz Cab Rentals in Mumbai, Mercedes Cab Hire Mumbai, Chauffeur Mercedes Mumbai, Executive Mercedes Mumbai, Mercedes Sedan Rental Mumbai, Mercedes SUV Rental Mumbai, Premium Mercedes Cab Mumbai, Corporate Mercedes Rental Mumbai, Best Mercedes Cab Mumbai, Affordable Mercedes Cab Mumbai, Mercedes Chauffeur Services Mumbai, Mercedes Packages Mumbai, Mercedes Car Hire Mumbai, Online Mercedes Cab Mumbai, Mercedes Chauffeur Booking Mumbai"
};






  return (
    <div>

<Helmet>
  <title>Mercedes Benz Cab Rentals in Mumbai | Luxury Mercedes Hire | Aaryan Travels</title>
  <meta
    name="description"
    content="Book chauffeur driven Mercedes Benz cab rentals in Mumbai with Aaryan Travels. Luxury Mercedes sedans and SUVs for executive and corporate travel."
  />
  <meta
    name="keywords"
    content="Mercedes Benz Cab Rentals in Mumbai, Mercedes Cab Hire Mumbai, Chauffeur Mercedes Mumbai, Executive Mercedes Mumbai, Mercedes Sedan Rental Mumbai, Mercedes SUV Rental Mumbai, Premium Mercedes Cab Mumbai, Corporate Mercedes Rental Mumbai, Best Mercedes Cab Mumbai, Affordable Mercedes Cab Mumbai, Mercedes Chauffeur Services Mumbai, Mercedes Packages Mumbai, Mercedes Car Hire Mumbai, Online Mercedes Cab Mumbai, Mercedes Chauffeur Booking Mumbai"
  />
  <script type="application/ld+json">
    {JSON.stringify(mercedesMumbaiSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/62.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mercedesbenzcabrentalsinmumbai;